module.exports = __webpack_public_path__ + "static/img/仓库3@2x.c38b5e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/仓库3@2x.png
// module id = 0ZfY
// module chunks = 1